'use strict'

import ApiClient from './ApiClient'
import qs from 'qs'

export default class MgTagRepository {
  /**
   * タグ情報一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/mgtags`, { params })
  }

  /**
   * 新しいタグ情報を作成
   * @param {object} data 登録データ
   * @returns {*}
   */
  post (data) {
    return ApiClient().post(`/mgtags`, qs.stringify(data))
  }

  /**
   * 指定されたidのタグ情報を取得
   * @param id タグid
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/mgtags/${id}`)
  }

  /**
   * 指定されたIDのタグ情報を更新
   * @param id タグid
   * @param {object} params 登録データ
   * @returns {*}
   */
  put (id, params) {
    return ApiClient().put(`/mgtags/${id}`, params)
  }

  /**
   * 指定されたidのタグ情報を削除
   * @param id タグid
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/mgtags/${id}`)
  }

  /**
   * 指定された複数IDのタグ情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/mgtags/delete`, data)
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/mgtags/sort`, params)
  }

  /**
   * タグの色候補を取得する
   * @returns {*}
   */
  getColors () {
    return ApiClient().get(`/mgtags/colors`)
  }

  /**
   * タグ選択ダイアログ用のタグ情報一覧を取得します。
   * @param {object} params
   * @returns {*}
   */
  getSelTags (params) {
    return ApiClient().get(`/mgtags/seltags`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/MgTagRepository.js